module.exports = __webpack_public_path__ + "static/media/logo-antoniogoncalves.3b3b78fd.png";